<template lang='pug'>
  i.svg-icon.svg-icon-loading
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 50 50'
    )
      path(
        :fill='color'
        d='M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z'
        transform='rotate(239.292 25 25)'
      )
        animateTransform(
          attributeType='xml'
          attributeName='transform'
          type='rotate' from='0 25 25'
          to='360 25 25'
          dur='0.7s'
          repeatCount='indefinite'
        )

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>